import { lengthToDegrees, Units } from '@turf/helpers';

export function distanceBtwCoordiantes(distance: number, unit: Units) {
  return lengthToDegrees(distance, unit);
}
